import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteEvolucaoAnimal } from '../service';
import {
  DELETE_EVOLUCAO_ANIMAL,
  DELETE_EVOLUCAO_ANIMAL_PENDING,
  DELETE_EVOLUCAO_ANIMAL_SUCCESS,
  DELETE_EVOLUCAO_ANIMAL_FAILURE,
} from '../actionTypes';

import { AlertError, AlertWarning } from '@components/common/AlertToast'

function* sagaDeleteEvolucaoAnimal(action) {
  yield put({ type: DELETE_EVOLUCAO_ANIMAL_PENDING, id: action.id })

  try {
    const a = yield call(deleteEvolucaoAnimal, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_EVOLUCAO_ANIMAL_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_EVOLUCAO_ANIMAL_FAILURE });

    if (error.response.status === 403) {
      AlertWarning('Evolução não pode ser excluída');
    } else {
      AlertError('Falha ao excluir a evolução! Tente novamente...');
    }
  }
}

export default function* watchDeleteEvolucaoAnimal() {
  yield takeLatest(DELETE_EVOLUCAO_ANIMAL, sagaDeleteEvolucaoAnimal)
}
